import { Badge, cn } from '@quickmd-llc/design-system'
import { getGrantVisitBadgeLabel } from '@quickmd-llc/frontend-utils'

type Props = {
  className?: string
  /**
   * The visit's `Coverage` block. `unknown` for the same reason the plan chip
   * takes it that way: some call sites hold the typed contract, others read the
   * visit out of untyped legacy Redux, and `getGrantVisitBadgeLabel` narrows it.
   */
  coverage: unknown
}

/**
 * The chip a grant-funded visit wears wherever staff see that visit — the grant
 * program's own name (`MS Grant`). Renders nothing when the visit was not
 * grant-funded, so callers drop it in unconditionally instead of repeating the
 * guard.
 *
 * Unlike the plan chip there is no feature flag: a grant either paid for the
 * visit or it did not, and that fact is not something to roll out.
 */
export function GrantVisitBadge({ className, coverage }: Props) {
  const label = getGrantVisitBadgeLabel(coverage)

  if (!label) {
    return null
  }

  // `font-sans` (Outfit) is not decoration: the design-system typography sets no
  // font-family, and this badge renders on legacy visit-info pages whose ambient
  // font is Helvetica, which the badge text would otherwise inherit. Setting it
  // on the badge wins over that inherited value.
  return (
    <Badge className={cn('font-sans', className)} size='s' variant='default'>
      {label}
    </Badge>
  )
}
